import { IntlProvider } from 'react-intl';
import zhCN from '../locales/zh-CN';
import enUS from '../locales/en-US';
import { useState } from 'react';

const messages = {
  'zh-CN': zhCN,
  'en-US': enUS,
};

export const IntlContainer = ({ children }) => {
  const [locale] = useState(localStorage.getItem('locale') || 'en-US');

  return (
    <IntlProvider messages={messages[locale]} locale={locale}>
      {children}
    </IntlProvider>
  );
}; 